import { MetricsClient } from '@agilelab/plugin-wb-metrics-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const metricsApiRef = createApiRef<MetricsClient>({
  id: 'wb-metrics',
});
